export default "__VITE_ASSET__C$2Xjs6C__"